export function toNumber(thiftDate) {
    if (thiftDate && thiftDate.buffer) {
        return thiftDate.buffer.readUIntBE(0, thiftDate.buffer.length);
    }
    return thiftDate;
}
